import noImage from "../../src/assets/no-image.png";
import logoDana from "../assets/logoDana.png";
import logoOvo from "../assets/logoOvo.png";
import logoMandiri from "../assets/mandiri.png";
import logoBri from "../assets/bri.svg";
import logoBni from "../assets/bni.svg";
import logoCimb from "../assets/cimb.svg";
import logoPermata from "../assets/permata.svg";
import logoSampoerna from "../assets/sampoerna.svg";
import logoBjb from "../assets/bjb.svg";
import logoBsi from "../assets/bsi.svg";
import logoQris from "../assets/qris.svg";
import logoJnt from "../assets/logoJnt.png";
import logoSmile from "../assets/smile.png";
import EditIcon from '@mui/icons-material/Edit';
import PersonIcon from '@mui/icons-material/Person';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';

import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Navigation from "./navigation";
import Footer from "./components/footer/footer";
import {
  Alert,
  Autocomplete,
  Backdrop,
  Box,
  Button,
  Checkbox,
  Container,
  createTheme,
  Fade,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  Grid,
  IconButton,
  Modal,
  Radio,
  RadioGroup,
  Snackbar,
  SnackbarContent,
  Step,
  StepLabel,
  Stepper,
  TextareaAutosize,
  TextField,
  ThemeProvider,
  Typography,
} from "@mui/material";
import { useAuth } from "../authContext";
import CustomerService from "../services/customer/customerService";
import { NumericFormat } from "react-number-format";
import { AddressService } from "../services/customer/addressService";
import { QRCodeCanvas } from "qrcode.react";
import { autocompleteStyleBlack, blackHex, btnStyle, btnStyleText, checkboxStyle, discountHex, fontSizeText, grayHex, headerStyle, lightergrayHex, lightgrayHex, styleModal, subHeaderStyle, subHeaderStyleContrast, textfieldStyle, textfieldStyleBlack, textSmallStyle, textStyle, textStyleContrast } from "../helper/style";
import LiqueModal from "./components/liqueModal";
import useCheckoutStore from "../store/checkoutStore";

const imageUrl = process.env.REACT_APP_IMAGE_URL
const theme = createTheme({
  components: {
    MuiStepIcon: {
      styleOverrides: {
        root: {
          "&.Mui-active": {
            color: "#FE8A01",
          },
          "&.Mui-completed": {
            color: "#FE8A01",
          },
        },
      },
    },
  },
});

const btnStyleLocal = {
  borderRadius: "50px",
  width: "100%",
  padding: 10,
  boxShadow: 24,
  color: "white",
  fontWeight: "bold",
  backgroundColor: "black",
  textTransform: "none",
};

const btnStyleDisabled = {
  borderRadius: "50px",
  width: "100%",
  padding: 10,
  boxShadow: 24,
  color: "white",
  fontWeight: "bold",
  backgroundColor: "black",
  textTransform: "none",
  opacity: "0.2"
};

const radioStyle = {
  color: "white !important",
  '&.Mui-checked': {
    color: "white",
  },
}

const methodItemStyle = {
  marginTop: "24px",
  minHeight: "96px",
  height: "auto",
  width: "99%",
  borderRadius: "20px",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  "&:hover": {
    bgcolor: "rgba(0, 0, 0, 0.23)",
  },
}

const CheckoutPage2 = ({ state = "cart" }) => {
  const [ShowSuccess, setShowSuccess] = useState(false);
  const [MsgSuccess, setMsgSuccess] = useState("");
  const [showError, setShowError] = useState(false);
  const [msgError, setMsgError] = useState();
  const [errors, setErrors] = useState([]);
  const [ableToProceed, setAbleToProceed] = useState(false);
  
  const { item, removeItem, discount: storedDiscount, removeDiscount } = useCheckoutStore();
  
  const [custData, setCustData] = useState(null);
  const [orderData, setOrderData] = useState([]);
  const [addressList, setAddressList] = useState([]);
  const [addressData, setAddressData] = useState(null);
  const [deliveryCourier, setDeliveryCourier] = useState("JNT");
  const [paymentMethod, setPaymentMethod] = useState(null);
  const [paymentChannel, setPaymentChannel] = useState(null);
  const [discountCode, setDiscountCode] = useState(storedDiscount ? storedDiscount.code : "");
  const [discountId, setDiscountId] = useState(storedDiscount ? storedDiscount.id : null);
  const [loadingAddPayment, setLoadingAddPayment] = useState(false);
  const [paymentInfo, setPaymentInfo] = useState(null);
  const [pollingInterval, setPollingInterval] = useState(null);

  const [addressDialog, setAddressDialog] = useState(false);
  const [ewalletDialog, setEwalletDialog] = useState(false);
  const [virtualAccountDialog, setVirtualAccountDialog] = useState(false);
  const [editAddressId, setEditAddressId] = useState(false);
  const [addAddressDialog, setAddAddressDialog] = useState(false);
  const [informationDialog, setInformationDialog] = useState(false);
  const [successDialog, setSuccessDialog] = useState(false);
  
  const [subtotal, setSubtotal] = useState(0);
  const [grandTotal, setGrandTotal] = useState(0);
  const [deliveryFee, setDeliveryFee] = useState(null);
  const [adminFee, setAdminFee] = useState(null);
  const [discount, setDiscount] = useState(0);

  const [provinces, setProvinces] = useState([]);
  const [cities, setCities] = useState([]);
  const [zipcodes, setZipcodes] = useState([]);
  const [subDistricts, setSubDistricts] = useState([]);
  const [neighborhoods, setNeighborhoods] = useState([]);
  const [selectedProvince, setSelectedProvince] = useState(null);
  const [selectedCity, setSelectedCity] = useState(null);
  const [selectedSubDistrict, setSelectedSubDistrict] = useState(null);
  const [selectedNeighborhood, setselectedNeighborhood] = useState(null);
  const [selectedZipcode, setSelectedZipcode] = useState(null);
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [isDefault, setIsDefault] = useState(false);
  const [addressNotes, setAddressNotes] = useState("");

  const [openDelete, setOpenDelete] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [loadingDelete, setLoadingDelete] = useState(false);

  const { auth } = useAuth();
  const navigate = useNavigate();

  const getPembayaran = (paymentData) => {
    if (paymentData.method === 'CASH_ON_DELIVERY') {
      return "COD";
    } else {
      switch (paymentData.channel) {
        case 'QRIS':
          return "QRIS";
        case 'OVO':
          return "OVO";
        case 'DANA':
          return "Dana";
        case 'MANDIRI':
          return "Mandiri Virtual Account";
        case 'BRI':
          return "BRI Virtual Account";
        case 'BNI':
          return "BNI Virtual Account";
        case 'CIMB':
          return "CIMB Virtual Account";
        case 'PERMATA':
          return "Permata Virtual Account";
        case 'SAHABAT_SAMPOERNA':
          return "Sahabat Sampoerna Virtual Account";
        case 'BJB':
          return "BJB Virtual Account";
        case 'BSI':
          return "BSI Virtual Account";
        default:
          return "";
      }
    }
  }

  const handleCloseDelete = () => {
    setDeleteId(null);
    setOpenDelete(false);
  };

  const handleOpenDelete = (orderId) => {
    setDeleteId(orderId);
    setOpenDelete(true);
  };

  const activateSuccess = () => {
    setShowSuccess(true);
    setTimeout(() => {
      setShowSuccess(false);
    }, 5000);
  };

  const activateError = () => {
    setShowError(true);
    setTimeout(() => {
      setShowError(false);
    }, 5000);
  };

  const findDiscount = async () => {
      try {
        const response = await CustomerService.getDiscountVoucher(discountCode || '');
        if (response) {
          const data = response.data.discount;
          if (data == null) {
            setMsgError("Discount code not found");
            activateError();
            setDiscountId(null);
          } else {
            if (subtotal < data.minSpend) {
              setMsgError(`Minimum purchase for this discount code is Rp. ${data.minSpend}`);
              activateError();
              setDiscountId(null);
            } else {
              setMsgSuccess("Successfully applied discount code");
              activateSuccess();
              setDiscountId(data.id)
            }
          }
        }
      } catch (error) {
        console.error(error);
      }
    }

  const createPayment = async () => {
    try {
      setLoadingAddPayment(true);
      let response = null;
      if (state === 'cart') {
        response = await CustomerService.createPayment(
          custData.phonenumber,
          paymentMethod,
          paymentChannel,
          addressData?.id,
          orderData.map(order => order.id),
          discountId
        );
      } else if (state === 'buy-now') {
        response = await CustomerService.createPaymentBuyNow(
          custData.phonenumber,
          paymentMethod,
          paymentChannel,
          addressData?.id,
          item.itemId,
          item.variantId,
          item.quantity,
          discountId
        );
      }

      if (response) {
        const data = response.data;
        let paymentInformation = null;
        if (paymentMethod === "VIRTUAL_ACCOUNT") {
          paymentInformation = {
            virtualAccountNumber: data.virtualAccountNumber,
            referenceId: data.referenceId,
          };
        } else if (paymentMethod === "EWALLET") {
          paymentInformation = {
            message: "Please continue payment in your E-Wallet application",
            referenceId: data.referenceId,
          };
        } else if (paymentMethod === "QR_CODE") {
          paymentInformation = {
            qrCode: data.qrCode,
            referenceId: data.referenceId,
            totalPrice: data.totalPrice,
          };
        } else if (paymentMethod === "CASH_ON_DELIVERY") {
          paymentInformation = {
            referenceId: data.referenceId,
            totalPrice: data.totalPrice,
            message: "Please wait a moment"
          }
        }

        if (paymentInformation !== null) {
          startPolling(data.referenceId);
        }

        setPaymentInfo(paymentInformation);
        setInformationDialog(true);

        removeItem();
        removeDiscount();

        if (data.paymentLink) {
          window.open(data.paymentLink, "_blank");
        }
      }
    } catch (error) {
      console.error(error);
      setMsgError("Error while creating payment");
      activateError();
    } finally {
      setLoadingAddPayment(false);
    }
  }

  const startPolling = (referenceId) => {
    const intervalId = setInterval(async () => {
      try {
        const response = await CustomerService.getPaymentStatus(referenceId);
        if (response) {
          const status = response?.data?.status;
  
          if (status === "SUCCEEDED") {
            clearInterval(intervalId); 
            setPollingInterval(null); 
  
            setSuccessDialog(true);
  
            setTimeout(() => {
              setSuccessDialog(false);
              navigate("/customer/profile?page=history");
            }, 5000);
          }
        }
      } catch (error) {
        console.error("Error checking payment status:", error);
      }
    }, 3000); 

    setPollingInterval(intervalId); 
  };

  const getPaymentDataPreviewByCustomerId = async () => {
    try {
      let response = null;

      if (state === 'cart') {
        response = await CustomerService.getPaymentDataPreviewByCustomerId(
          custData.id,
          paymentMethod,
          paymentChannel,
          addressData?.id,
          discountId
        );

      } else if (state === 'buy-now') {
        response = await CustomerService.getBuyNowPreviewByCustomerId(
          custData.id,
          paymentMethod,
          paymentChannel,
          addressData?.id,
          item.itemId,
          item.variantId,
          item.quantity,
          discountId
        );
      }

      if (response) {
        const data = response.data;

        if (data) {
          const itemList = data?.details

          setOrderData(itemList);
          setSubtotal(data.price);
          setDeliveryFee(data.totalDeliveryFee);
          setAdminFee(data.transactionFee);
          setGrandTotal(data.totalPrice);
          setDiscount(data.discount);
        }
      }
    } catch (error) {
      console.error(error);
    }
  }

  const fetchDataAddress = async () => {
    try {
      const response = await AddressService.fetchDataAddress(custData.phonenumber);
      if (response) {
        const addressList = response.data.addressList
        setAddressList(addressList);

        if (addressData == null) {
          const defautAddress = addressList.find(address => address.isDefault);
          if (defautAddress) {
            setAddressData(defautAddress);
          }
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const fetchProvinces = async () => {
    try {
      const response = await AddressService.fetchProfinces();
      if (response) {
        setProvinces(response.data.provinceList);
      }
    } catch (error) {
      console.error("There was an error fetching the data!", error);
    }
  };

  const fetchCities = async (provinceId) => {
    try {
      const response = await AddressService.fetchCities(provinceId);
      if (response) {
        setCities(response.data.districtList);
      }
    } catch (error) {
      console.error("There was an error fetching the data!", error);
    }
  };

  const fetchSubDistricts = async (provinceId, cityId) => {
    try {
      const response = await AddressService.fetchSubDistricts(provinceId, cityId);
      if (response) {
        setSubDistricts(response.data.subdistrictList);
      }
    } catch (error) {
      console.error("There was an error fetching the data!", error);
    }
  };

  const fetchNeighborhoods = async (provinceId, cityId, subDistrictId) => {
    try {
      const response = await AddressService.fetchNeighborhoods(provinceId, cityId, subDistrictId);
      if (response) {
        setNeighborhoods(response.data.neighborhoodList);
      }
    } catch (error) {
      console.error("There was an error fetching the data!", error);
    }
  }

  const fetchZipCode = async (provinceId, cityId, subDistrictId, neighborhoodId) => {
    try {
      const response = await AddressService.fetchZipCode(provinceId, cityId, subDistrictId, neighborhoodId);
      if (response) {
        setZipcodes(response.data.zipCodeList);
      }
    } catch (error) {
      console.error("There was an error fetching the data!", error);
    }
  }

  const submitAddress = async () => {
    if (!validate()) return;

    try {
      let response = null;
      if (editAddressId != null) {
        response = await AddressService.updateAddress(
          custData.phonenumber,
          editAddressId,
          selectedProvince,
          selectedCity,
          selectedSubDistrict,
          selectedNeighborhood,
          selectedZipcode, 
          selectedAddress,
          isDefault,
          addressNotes
        )
      } else {
        response = await AddressService.addAddress(
          custData.phonenumber,
          selectedProvince,
          selectedCity,
          selectedSubDistrict,
          selectedNeighborhood,
          selectedZipcode, 
          selectedAddress,
          isDefault,
          addressNotes
        );

      }

      if (response) {
        fetchDataAddress();

        setAddAddressDialog(false);
        setSelectedAddress(null);
        setSelectedProvince(null);
        setSelectedCity(null);
        setSelectedSubDistrict(null);
        setselectedNeighborhood(null);
        setSelectedZipcode(null);
        setIsDefault(false);
        setEditAddressId(null);
        setAddressNotes("");
      }
    } catch (error) {
      console.error(error);
      if (error.response.status === 400) {
        const message = error.response?.data?.message;
        setMsgError(message);
      } else {
        if (editAddressId) {
          setMsgError("Error while updating address");
        } else {
          setMsgError("Error while adding new address");
        }
      }
      activateError();
    }
  }

  useEffect(() => {
    setCustData(auth?.user);
  }, [auth]);

  useEffect(() => {
    if (custData) {
      getPaymentDataPreviewByCustomerId();
      fetchDataAddress();
      fetchProvinces();
    }
  }, [custData]);

  useEffect(() => {
    if (addressData != null || paymentChannel != null) {
      getPaymentDataPreviewByCustomerId();
    }

    if (addressData != null && deliveryCourier != null && paymentChannel != null && paymentMethod != null) {
      setAbleToProceed(true);
    } else {
      setAbleToProceed(false);
    }
  }, [addressData, deliveryCourier, paymentChannel, paymentMethod, discountId])

  const handleChooseAddress = (address) => {
    setAddressData(address);
    setAddressDialog(false);
  }
  
  useEffect(() => {
    return () => {
      if (pollingInterval) clearInterval(pollingInterval);
    };
  }, [pollingInterval]);

  const handleOpenAddressDialog = () => {
    setAddressDialog(true);
  }

  const handleCloseAddressDialog = () => {
    setAddressDialog(false);
  }

  const handleOpenAddAddress = async (address = null) => {
    fetchProvinces();
    if (address != null && address !== undefined) {
      setEditAddressId(address.id);
      fetchCities(address.province);
      fetchSubDistricts(address.province, address.district);
      fetchNeighborhoods(address.province, address.district, address.subdistrict);
      fetchZipCode(address.province, address.district, address.subdistrict, address.neighborhood);

      setSelectedAddress(address.detail);
      setSelectedProvince(address.province);
      setSelectedCity(address.district);
      setSelectedSubDistrict(address.subdistrict);
      setselectedNeighborhood(address.neighborhood);
      setSelectedZipcode(address.zipCode);
      setIsDefault(address.isDefault);
      setAddressNotes(address.notes);
    }

    setAddAddressDialog(true);
  }

  const handleCloseAddAddress = () => {
    setAddAddressDialog(false);
    setEditAddressId(null);

    setSelectedAddress("");
    setSelectedProvince(null);
    setSelectedCity(null);
    setSelectedSubDistrict(null);
    setselectedNeighborhood(null);
    setSelectedZipcode(null);
    setIsDefault(false);
    setAddressNotes("");
  }

  const setPaymentData = (paymentMethod, paymentChannel) => {
    setPaymentMethod(paymentMethod);
    setPaymentChannel(paymentChannel);
  }
  
  const setEwalletPaymentData = (paymentChannel) => {
    setPaymentMethod("EWALLET");
    setPaymentChannel(paymentChannel);

    setEwalletDialog(false);
  }

  const setVAPaymentData = (paymentChannel) => {
    setPaymentMethod("VIRTUAL_ACCOUNT");
    setPaymentChannel(paymentChannel);

    setVirtualAccountDialog(false);
  }

  const handleCloseInformation = (event, reason) => {
    if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
      informationDialog(false);
    }
  }

  const validate = () => {
    let tempErrors = {};

    if (!selectedAddress) {
      tempErrors.address = "Address is required";
    } else if (selectedAddress.length > 90) {
      tempErrors.address = "Address can be a maximum of 90 characters";
    }

    if (!selectedCity) {
      tempErrors.city = "City is required";
    }

    if (!selectedProvince) {
      tempErrors.state = "Province is required";
    }

    if (!selectedZipcode) {
      tempErrors.zipcode = "Zipcode is required";
    } else if (selectedZipcode.length > 6) {
      tempErrors.zipcode = "Zipcode can be a maximum of 6 characters";
    }

    if (addressNotes.length > 100) {
      tempErrors.notes = "Notes can be a maximum of 100 characters";
    }

    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  return (
    <>
      <Navigation />

      <Container component="main" maxWidth="xl" sx={{ marginBottom: "50px", marginTop: "60px" }}>
        <Snackbar
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          open={ShowSuccess}
          autoHideDuration={3000}
          onClose={() => setShowSuccess(false)}
        >
          <SnackbarContent
            sx={{ backgroundColor: "#19B600" }} 
            message={MsgSuccess}/>
        </Snackbar>
  
        <Snackbar
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          open={showError}
          autoHideDuration={3000}
          onClose={() => setShowError(false)}
        >
          <SnackbarContent 
            sx={{ backgroundColor: "#E50B0B" }} 
            message={msgError}/>
        </Snackbar>

        <Box marginTop={5}>
          <Typography sx={{ ...headerStyle }} fontWeight="bold" textTransform="uppercase">
            Checkout
          </Typography>

          <Grid container marginTop={2} columnSpacing={6} position="relative">
            <Grid item xs={12} md={6} lg={8} marginBottom={2}>
              <Box paddingX={3} paddingY={2} marginTop={2} 
                sx={{ background: grayHex, borderRadius: "16px"  }}
                display="flex" justifyContent="center" flexDirection="column">
                <Box marginBottom={2} display="flex" justifyContent="space-between" alignItems="center">
                  <Typography sx={{ ...subHeaderStyle}}>
                    Shipping Address
                  </Typography>
                  <Button sx={{ ...btnStyleText }} onClick={handleOpenAddressDialog} startIcon={<EditOutlinedIcon />}>
                    Change Address
                  </Button>
                </Box>
                {
                  addressData == null ? (
                    <Box>
                      <Typography sx={{ ...textStyle }}  fontWeight="bold">
                        Select a shipping address to continue
                      </Typography>
                    </Box>
                  ) : (
                    <>
                      <Box>
                        <Typography sx={{ ...textStyle, fontWeight: "bold" }}>
                          {addressData.detail}
                        </Typography>
                      </Box>
                      <Box>
                        <Typography sx={{ ...textStyle }}>
                          {addressData.province}, {addressData.district},{" "}
                          {addressData.subdistrict}, {addressData.neighborhood},{" "}
                          {addressData.zipCode}
                        </Typography>
                      </Box>
                      <Box>
                        <Typography sx={{ ...textSmallStyle }}>
                          Notes: {addressData.notes || '-'}
                        </Typography>
                      </Box>
                    </>
                  )
                }
              </Box>

              {
                orderData.map((detail, index) => (
                  <React.Fragment key={index}>
                    <Box paddingX={3} paddingY={2} marginTop={2}
                      sx={{ background: grayHex, borderRadius: "16px"  }}
                      display="flex" justifyContent="center" flexDirection="column">
                      <Box marginBottom={2}>
                        <Typography sx={{ ...subHeaderStyle }}>
                          Product Details
                        </Typography>
                      </Box>
                      {
                        detail.itemList.map((order, orderIndex) => (
                          <Grid container key={orderIndex}>
                            <Grid item xs={12} md={2}>
                              <Box sx={{ 
                                width: "100%",
                                maxWidth: "80px",
                                aspectRatio: "1 / 1",
                                borderRadius: "16px",
                                overflow: "hidden"
                              }}>
                                <img
                                  src={
                                    order.item.images?.length <= 0 || order.item.images == null
                                      ? noImage
                                      : `${imageUrl}${order.item.images[0]}`
                                  }
                                  alt={order.item.name}
                                  style={{
                                    width: "100%",
                                    objectFit: "cover",
                                    marginRight: "3%"
                                  }}
                                ></img>
                              </Box>
                            </Grid>
        
                            <Grid item xs={12} md={6}>
                              {
                                order.item.brand && (
                                  <>
                                    <img 
                                      src={order.item.brand?.images == null ? noImage : `${imageUrl}${order.item.brand?.images[0]}`}
                                      alt={order.item.brand.title}
                                      style={{ width: "20%", aspectRatio: "1 / 1", objectFit: "contain" }}
                                    />
                                  </>
                                )
                              }
                              <Typography sx={{ ...textStyle }}>
                                {order.item?.name}, Size: {order.variant?.size}
                              </Typography>
                            </Grid>
        
                            <Grid item xs={12} md={4} display="flex" alignItems="center">
                              <Box>
                                <Typography sx={{ ...textSmallStyle }}>
                                  Total
                                </Typography>
                                <Typography sx={{ ...textStyle, fontWeight: "bold" }}>
                                  {order.quantity} x {" "}
                                  <NumericFormat
                                    value={order.item.showDiscount ? order.item.defaultPrice - order.item.discountValue : order.item.defaultPrice}
                                    displayType={"text"}
                                    thousandSeparator="."
                                    decimalSeparator=","
                                    prefix={"RP "}
                                  />
                                </Typography>
                                {
                                  order.item.showDiscount && (
                                    <Box display="flex" gap="10px" marginTop={1} alignItems="center">
                                      <Typography sx={{ ...textSmallStyle, color: lightergrayHex, textDecoration: "line-through" }}>
                                        <NumericFormat
                                          value={order.item.defaultPrice}
                                          displayType={"text"}
                                          thousandSeparator="."
                                          decimalSeparator=","
                                          prefix={"Rp. "}
                                        />
                                      </Typography>
                                      <Box sx={{ background: discountHex, padding: "2px 5px" }}>
                                        <Typography sx={{ ...textSmallStyle }}>
                                          <NumericFormat
                                            value={order.item.discountPercent}
                                            displayType={"text"}
                                            thousandSeparator="."
                                            decimalSeparator=","
                                            suffix='%'
                                          />
                                        </Typography>
                                      </Box>
                                    </Box>
                                  )
                                }
                              </Box>
                            </Grid>
                          </Grid>
                        ))
                      }

                      <Box marginTop={2}
                        display="flex" justifyContent="center" flexDirection="column">
                        <Box marginBottom={2}>
                          <Typography sx={{ ...subHeaderStyle }}>
                            Shipping Method
                          </Typography>
                        </Box>
                        <Box item xs={12} sx={{
                          border: "1px solid white",
                          borderTopLeftRadius: "15px",
                          borderTopRightRadius: "15px",
                          display: "flex",
                          alignItems: "center",
                          padding: "15px",
                          justifyContent: "space-between",
                          cursor: "pointer", 
                        }}>
                          <Typography sx={{ ...textStyle }}>Regular</Typography>
                          {/* <ExpandMoreIcon sx={{ color: "white" }} /> */}
                        </Box>
                        <Box item xs={12} sx={{
                          border: "1px solid white",
                          borderBottomLeftRadius: "15px",
                          borderBottomRightRadius: "15px",
                          borderTop: "unset",
                          padding: "15px",
                          cursor: "pointer", 
                        }}>
                          <Box sx={{ 
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between" 
                          }}>
                            <Typography sx={{ ...textStyle }}>
                              J&T (
                                {
                                  detail.deliveryFee === null ? (<i>Not Calculated Yet</i>) : (
                                    <NumericFormat value={detail.deliveryFee} displayType={"text"}
                                      thousandSeparator="." decimalSeparator="," prefix={"Rp. "}/>
                                  )
                                }
                              )
                            </Typography>
                            {/* <ExpandMoreIcon sx={{ color: "white" }} /> */}
                          </Box>
                        </Box>
                      </Box>
                    </Box>
                  </React.Fragment>
                ))
              }

              <Box paddingX={3} paddingY={2} marginTop={2} 
                sx={{ background: grayHex, borderRadius: "16px"  }}
                display="flex" justifyContent="center" flexDirection="column">
                <Box marginBottom={2}>
                  <Typography sx={{ ...subHeaderStyle }}>
                    Payment Method
                  </Typography>
                  <Grid container marginTop={3}>
                    <Grid item xs={12}>
                      <Box onClick={() => setEwalletDialog(true)} sx={{cursor: "pointer"}}>
                        <Grid container alignItems="center">
                          <Grid item xs={2} md={1}>
                            <Radio sx={radioStyle} disabled checked={paymentMethod === "EWALLET"}/>
                          </Grid>
                          <Grid item xs={4} md={3} sx={{ ...textStyle }}>
                            E-Wallet
                          </Grid>
                          <Grid item xs={6} md={8} sx={{ display: "flex", alignItems: "center", justifyContent: "end", flexWrap: "wrap" }}>
                            <img src={logoDana} alt="Dana Logo" width={60} style={{ paddingRight: "10px" }} />
                            <img src={logoOvo} alt="OVO Logo" width={60} style={{ paddingRight: "10px" }} />
                          </Grid>
                        </Grid>
                      </Box>

                      <Box onClick={() => setVirtualAccountDialog(true)} sx={{cursor: "pointer"}}>
                        <Grid container alignItems="center">
                          <Grid item xs={2} md={1}>
                            <Radio sx={radioStyle} disabled checked={paymentMethod === "VIRTUAL_ACCOUNT"}/>
                          </Grid>
                          <Grid item xs={4} md={3} sx={{ ...textStyle }}>
                            Virtual Account
                          </Grid>
                          <Grid item xs={6} md={8} sx={{ display: "flex", alignItems: "center", justifyContent: "end", flexWrap: "wrap" }}>
                            <img src={logoMandiri} alt="Mandiri Logo" width={45} style={{ paddingRight: "10px" }}/>
                            <img src={logoBri} alt="BRI Logo" width={45} style={{ paddingRight: "10px" }}/>
                            <img src={logoBni} alt="BNI Logo" width={45} style={{ paddingRight: "10px" }} />
                            <img src={logoCimb} alt="CIMB Logo" width={45} style={{ paddingRight: "10px" }} />
                            <img src={logoPermata} alt="Permata Logo" width={45} style={{ paddingRight: "10px" }} />
                            <img src={logoSampoerna} alt="Sampoerna Logo" width={45} style={{ paddingRight: "10px" }} />
                            <img src={logoBjb} alt="BJB Logo" width={45} style={{ paddingRight: "10px" }} />
                            <img src={logoBsi} alt="BSI Logo" width={45} style={{ paddingRight: "10px" }} />
                          </Grid>
                        </Grid>
                      </Box>

                      <Box onClick={() => setPaymentData("QR_CODE", "QRIS")} sx={{cursor: "pointer"}}>
                        <Grid container alignItems="center">
                          <Grid item xs={2} md={1}>
                            <Radio sx={radioStyle} disabled checked={paymentMethod === "QR_CODE"}/>
                          </Grid>
                          <Grid item xs={4} md={3} sx={{ ...textStyle }}>
                            QRIS
                          </Grid>
                          <Grid item xs={6} md={8} sx={{ display: "flex", alignItems: "center", justifyContent: "end", flexWrap: "wrap" }}>
                            <img src={logoQris} alt="QRIS Logo" width={45} style={{ paddingRight: "10px" }} />
                          </Grid>
                        </Grid>
                      </Box>

                      {/* <Box onClick={() => setPaymentData("CASH_ON_DELIVERY", "CASH_ON_DELIVERY")} sx={{cursor: "pointer"}}>
                        <Grid container alignItems="center">
                          <Grid item xs={2} md={1}>
                            <Radio sx={radioStyle} disabled checked={paymentMethod === "CASH_ON_DELIVERY"}/>
                          </Grid>
                          <Grid item xs={4} md={3} sx={{ ...textStyle }}>
                            Cash on Delivery (COD)
                          </Grid>
                        </Grid>
                      </Box> */}
                    </Grid>
                  </Grid>
                </Box>
              </Box>
            </Grid>

            <Grid item xs={12} md={6} lg={4} position="sticky" top="100px" alignSelf="flex-start" marginBottom={2}>
              <Box padding={2} sx={{ background: "white", borderRadius: "15px" }}>
                <Box marginBottom={1}>
                  <Typography sx={{ ...subHeaderStyleContrast }}>Order Summary</Typography>
                </Box>
                <Grid container marginBottom={1}>
                  <Grid item xs={7}>
                    <Typography sx={{ ...textStyleContrast }}>Total Product Price</Typography>
                  </Grid>
                  <Grid item xs={5} textAlign="end">
                    <Typography sx={{ ...textStyleContrast }}>
                      {/* {subtotal} */}
                      <NumericFormat value={subtotal} displayType={"text"}
                        thousandSeparator="." decimalSeparator="," prefix={"Rp. "}/>
                    </Typography>
                  </Grid>
                </Grid>

                <Grid container marginBottom={1}>
                  <Grid item xs={7}>
                    <Typography sx={{ ...textStyleContrast }}>Total Shipping Cost</Typography>
                  </Grid>
                  <Grid item xs={5} textAlign="end">
                    <Typography sx={{ ...textStyleContrast }}>
                      {
                        deliveryFee === null ? (<i>Not Calculated Yet</i>) : (
                          // {deliveryFee}
                          <NumericFormat value={deliveryFee} displayType={"text"}
                            thousandSeparator="." decimalSeparator="," prefix={"Rp. "}/>
                        )
                      }
                    </Typography>
                  </Grid>
                </Grid>

                <Grid container marginBottom={1}>
                  <Grid item xs={7}>
                    <Typography sx={{ ...textStyleContrast }}>Discount</Typography>
                  </Grid>
                  <Grid item xs={5} textAlign="end">
                    <Typography sx={{ ...textStyleContrast }}>
                      <NumericFormat value={discount} displayType={"text"} allowNegative={false}
                        thousandSeparator="." decimalSeparator="," 
                        prefix={discount <= 0 ? "Rp. " : "-Rp. "}/>
                    </Typography>
                  </Grid>
                </Grid>

                <Grid container marginBottom={1}>
                  <Grid item xs={7}>
                    <Typography sx={{ ...textStyleContrast }}>Admin Fee {getPembayaran({ method: paymentMethod, channel: paymentChannel })}</Typography>
                  </Grid>
                  <Grid item xs={5} textAlign="end">
                    <Typography sx={{ ...textStyleContrast }}>
                      {
                        adminFee === null ? (<i>Not Calculated Yet</i>) : (
                          <NumericFormat value={adminFee} displayType={"text"}
                            thousandSeparator="." decimalSeparator="," prefix={"Rp. "}/>
                        )
                      }
                    </Typography>
                  </Grid>
                </Grid>

                <Grid container sx={{ height: "50px" }} marginBottom={1} alignItems="center">
                  <Grid item xs={7}>
                    <Typography sx={{ ...textStyleContrast }} fontWeight="bold">Total</Typography>
                  </Grid>
                  <Grid item xs={5} textAlign="end">
                    <Typography sx={{ ...textStyleContrast }} fontWeight="bold">
                      <NumericFormat value={grandTotal} displayType={"text"}
                        thousandSeparator="." decimalSeparator="," prefix={"Rp. "}/>
                    </Typography>
                  </Grid>
                </Grid>

                <Box marginTop={3}>
                  <Typography sx={{ ...textStyleContrast }}>Enter Discount Code</Typography>
                  <Grid container marginTop={2} columnSpacing={1}>
                    <Grid item xs={7} md={8} lg={9}>
                      <TextField
                        fullWidth
                        autoComplete="off"
                        value={discountCode}
                        onChange={(e) => setDiscountCode(e.target.value)}
                        placeholder="Discount Code"
                        sx={{ borderRadius: "50px", border: ".5px solid #505862", '& .MuiOutlinedInput-notchedOutline': {border: "unset"}  }}
                      />
                    </Grid>
                    <Grid item xs={5} md={4} lg={3}>
                      <Button sx={{ 
                        border: ".5px solid #505862",
                        borderRadius: "50px",
                        color: "black",
                        fontWeight: "bold",
                        backgroundColor: "white",
                        textTransform: "none",
                        height: "59px",
                        width: "100%",
                      }} onClick={findDiscount}>
                        Apply
                      </Button>
                    </Grid>
                  </Grid>
                </Box>

                <Box marginTop={5}>
                  <Button style={ableToProceed ? btnStyleLocal : btnStyleDisabled} disabled={loadingAddPayment}
                    onClick={createPayment}
                  >
                    {loadingAddPayment ? 'Please wait...' :'Pay Now'}
                  </Button>
                </Box>
              </Box>
            </Grid>
          </Grid>
          
        </Box>
      </Container>

      <Footer />

      {/* MODALS */}
      <LiqueModal open={addressDialog} onClose={handleCloseAddressDialog} theme="dark">
        {
          addressList.length > 0 ? (
            <Box>
              {
                addressList.map(address => (
                  <Box position="relative"> 
                    <Box 
                      key={address.id}
                      sx={{
                        backgroundColor: "black",
                        color: "white",
                        borderRadius: "12px",
                        padding: 3,
                        marginY: 2,
                        cursor: "pointer"
                      }}
                      onClick={() => handleChooseAddress(address)}
                    >
                      <Grid container spacing={2} textAlign={"left"} justifyContent="space-between">
                        
                        <Grid item xs={8}>
                          <Grid container>
                            <Grid item xs={12}>
                              <Typography
                                component="h6"
                                sx={{ fontWeight: "600" }}
                              >
                                {address.detail}
                              </Typography>
                            </Grid>
                            <Grid item xs={12}>
                              <Typography component="h6">
                                {address.province}, {address.district},{" "}
                                {address.subdistrict}, {address.neighborhood},{" "}
                                {address.zipCode}
                              </Typography>
                            </Grid>
                            <Grid item xs={12}>
                              <Typography component="h6">
                                Notes: {address.notes || '-'} 
                              </Typography>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Box>

                    
                    <IconButton sx={{ color: "white", position: "absolute", right: "20px", top: "30%" }} onClick={() => handleOpenAddAddress(address)}>
                      <EditIcon />
                    </IconButton>
                  </Box>
                ))
              }
              <Box>
                <Grid container spacing={2}>
                  <Grid item xs={12} textAlign="center">
                    <Button
                      onClick={handleOpenAddAddress}
                      style={btnStyleLocal}
                    >
                      New Address
                    </Button>
                  </Grid>
                </Grid>
              </Box>
            </Box>
          ) : (
            <Box>
              <img src={logoSmile} alt="Smile Logo" width={100} />
              <Typography
                id="spring-modal-title"
                variant="h6"
                component="h3"
              >
                You haven't added any address yet.
              </Typography>
              <Box sx={{ mt: 2 }} textAlign="center">
                <Button
                  variant="contained"
                  onClick={handleOpenAddAddress}
                  style={btnStyleLocal}
                >
                  Add Your Location
                </Button>
              </Box>
            </Box>
          )
        }
      </LiqueModal>

      <LiqueModal open={addAddressDialog} onClose={handleCloseAddAddress} theme="dark">
        <form>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Typography sx={{ ...textStyle }}>Address *</Typography>
              <TextField
                fullWidth
                autoComplete="off"
                value={selectedAddress}
                error={!!errors.address}
                helperText={errors.address}
                FormHelperTextProps={{ sx: { color: "red" } }}
                onChange={(e) => setSelectedAddress(e.target.value)}
                placeholder="Jl. Melati Mas..." // Add this line
                sx={{ ...textfieldStyleBlack }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography sx={{ ...textStyle }}>Province *</Typography>
              <Autocomplete
                options={provinces} 
                getOptionLabel={(option) => option} 
                value={selectedProvince}
                onChange={(event, newValue) => {
                  setSelectedCity(null);
                  setSelectedSubDistrict(null);
                  setselectedNeighborhood(null);
                  setSelectedZipcode(null);

                  fetchCities(newValue);
                  setSelectedProvince(newValue);
                }}
                helperText={errors.selectedProvince}
                FormHelperTextProps={{ sx: { color: "red" } }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    margin="normal"
                    fullWidth
                    sx={{ 
                      '& .MuiInputBase-input': {
                        ...fontSizeText
                      },
                    }} 
                  />
                )}
                sx={{ ...autocompleteStyleBlack }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography sx={{ ...textStyle }}>City/Regency *</Typography>
              <Autocomplete
                options={cities}
                getOptionLabel={(option) => option}
                value={selectedCity}
                onChange={(event, newValue) => {
                  setSelectedSubDistrict(null);
                  setselectedNeighborhood(null);
                  setSelectedZipcode(null);

                  fetchSubDistricts(selectedProvince, newValue);
                  setSelectedCity(newValue);
                }}
                helperText={errors.selectedCity}
                FormHelperTextProps={{ sx: { color: "red" } }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    margin="normal"
                    fullWidth
                    sx={{ 
                      '& .MuiInputBase-input': {
                        ...fontSizeText
                      },
                    }} 
                  />
                )}
                disabled={selectedProvince === null}
                sx={{ ...autocompleteStyleBlack }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography sx={{ ...textStyle }}>District *</Typography>
              <Autocomplete
                options={subDistricts} 
                getOptionLabel={(option) => option} 
                value={selectedSubDistrict}
                onChange={(event, newValue) => {
                  setselectedNeighborhood(null);
                  setSelectedZipcode(null);

                  fetchNeighborhoods(selectedProvince, selectedCity, newValue);
                  setSelectedSubDistrict(newValue);
                }}
                helperText={errors.selectedProvince}
                FormHelperTextProps={{ sx: { color: "red" } }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    margin="normal"
                    fullWidth
                    sx={{ 
                      '& .MuiInputBase-input': {
                        ...fontSizeText
                      },
                    }} 
                  />
                )}
                disabled={selectedCity === null}
                sx={{ ...autocompleteStyleBlack }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography sx={{ ...textStyle }}>Sub-district/Village *</Typography>
              <Autocomplete
                options={neighborhoods}
                getOptionLabel={(option) => option}
                value={selectedNeighborhood}
                onChange={(event, newValue) => {
                  setselectedNeighborhood(newValue);
                  fetchZipCode(selectedProvince, selectedCity, selectedSubDistrict, newValue);
                }}
                helperText={errors.selectedCity}
                FormHelperTextProps={{ sx: { color: "red" } }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    margin="normal"
                    fullWidth
                    sx={{ 
                      '& .MuiInputBase-input': {
                        ...fontSizeText
                      },
                    }} 
                  />
                )}
                disabled={selectedSubDistrict === null}
                sx={{ ...autocompleteStyleBlack }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography sx={{ ...textStyle }}>Postal Code *</Typography>
              <Autocomplete
                options={zipcodes}
                getOptionLabel={(option) => option}
                value={selectedZipcode}
                onChange={(event, newValue) =>
                  setSelectedZipcode(newValue)
                }
                helperText={errors.selectedCity}
                FormHelperTextProps={{ sx: { color: "red" } }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    margin="normal"
                    fullWidth
                    sx={{ 
                      '& .MuiInputBase-input': {
                        ...fontSizeText
                      },
                    }} 
                  />
                )}
                disabled={selectedNeighborhood === null}
                sx={{ ...autocompleteStyleBlack }}
              />
            </Grid>
            <Grid item xs={12} md={6} alignSelf="center">
              <FormControlLabel control={<Checkbox sx={{ ...checkboxStyle }} checked={isDefault} onChange={(_event, checked) => setIsDefault(checked)}/>} 
                label="Set as Default" sx={{ '& .MuiTypography-root': {...textStyle} }}/>
            </Grid>
            <Grid item xs={12}>
              <Typography sx={{ ...textStyle }}>Notes</Typography>
              <TextareaAutosize
                style={{ width: "96%", background: blackHex, border: `1px solid ${blackHex}`, borderRadius: '4px !important', marginTop: "10px", color: "white" }}
                minRows={3}
                value={addressNotes}
                onChange={(e) => setAddressNotes(e.target.value)}
              />
              {!!errors.notes ? (
                <FormHelperText sx={{ color: "red" }}>
                  {errors.notes}
                </FormHelperText>
              ) : null}
            </Grid>
            <Grid item xs={12}>
              <Button
                variant="contained"
                onClick={submitAddress}
                fullWidth
                style={{
                  backgroundColor: "black",
                  color: "white",
                }}
              >
                Submit
              </Button>
            </Grid>
          </Grid>
        </form>
      </LiqueModal>

      <LiqueModal open={ewalletDialog} onClose={() => setEwalletDialog(false)}>
        <Box onClick={() => setEwalletPaymentData("DANA")}
          sx={{
            ...methodItemStyle,
            border:
              paymentChannel === "DANA"
                ? "4px solid rgb(254, 138, 1)"
                : "2px solid black",
          }}
        >
          <Grid container sx={{ textAlign: "left", padding: "20px", }}>
            <Grid item xs={8} sx={{ display: "flex", alignItems: "center" }}>
              DANA
            </Grid>
            <Grid item xs={4} sx={{ display: "flex", alignItems: "center" }}>
              <img src={logoDana} alt="Dana Logo"
                width={120} style={{ transition: "background-color 0.3s", maxWidth: "100%" }}/>
            </Grid>
          </Grid>
        </Box>

        <Box onClick={() => setEwalletPaymentData("OVO")}
          sx={{
            ...methodItemStyle,
            border:
              paymentChannel === "OVO"
                ? "4px solid rgb(254, 138, 1)"
                : "2px solid black",
          }}
        >
          <Grid container sx={{ textAlign: "left", padding: "20px", }}>
            <Grid item xs={8} sx={{ display: "flex", alignItems: "center" }}>
              OVO
            </Grid>
            <Grid item xs={4} sx={{ display: "flex", alignItems: "center" }}>
              <img src={logoOvo} alt="OVO Logo"
                width={120} style={{ transition: "background-color 0.3s", maxWidth: "100%"  }}/>
            </Grid>
          </Grid>
        </Box>
      </LiqueModal>

      <LiqueModal open={virtualAccountDialog} onClose={() => setVirtualAccountDialog(false)}>
        <Box onClick={() => setVAPaymentData("MANDIRI")}
          sx={{
            ...methodItemStyle,
            border:
              paymentChannel === "MANDIRI"
                ? "4px solid rgb(254, 138, 1)"
                : "2px solid black",
          }}
        >
          <Grid container sx={{ textAlign: "left", padding: "20px", }}>
            <Grid item xs={8} sx={{ display: "flex", alignItems: "center" }}>
              Mandiri Virtual Account
            </Grid>
            <Grid item xs={4} sx={{ display: "flex", alignItems: "center" }}>
              <img src={logoMandiri} alt="Mandiri Logo"
                width={120} style={{ transition: "background-color 0.3s", maxWidth: "100%"  }}/>
            </Grid>
          </Grid>
        </Box>

        <Box onClick={() => setVAPaymentData("BRI")}
          sx={{
            ...methodItemStyle,
            border:
              paymentChannel === "BRI"
                ? "4px solid rgb(254, 138, 1)"
                : "2px solid black",
          }}
        >
          <Grid container sx={{ textAlign: "left", padding: "20px", }}>
            <Grid item xs={8} sx={{ display: "flex", alignItems: "center" }}>
              BRI Virtual Account
            </Grid>
            <Grid item xs={4} sx={{ display: "flex", alignItems: "center" }}>
              <img src={logoBri} alt="BRI Logo"
                width={120} style={{ transition: "background-color 0.3s", maxWidth: "100%"  }}/>
            </Grid>
          </Grid>
        </Box>

        <Box onClick={() => setVAPaymentData("BNI")}
          sx={{
            ...methodItemStyle,
            border:
              paymentChannel === "BNI"
                ? "4px solid rgb(254, 138, 1)"
                : "2px solid black",
          }}
        >
          <Grid container sx={{ textAlign: "left", padding: "20px", }}>
            <Grid item xs={8} sx={{ display: "flex", alignItems: "center" }}>
              BNI Virtual Account
            </Grid>
            <Grid item xs={4} sx={{ display: "flex", alignItems: "center" }}>
              <img src={logoBni} alt="BNI Logo"
                width={120} style={{ transition: "background-color 0.3s", maxWidth: "100%"  }}/>
            </Grid>
          </Grid>
        </Box>

        <Box onClick={() => setVAPaymentData("CIMB")}
          sx={{
            ...methodItemStyle,
            border:
              paymentChannel === "CIMB"
                ? "4px solid rgb(254, 138, 1)"
                : "2px solid black",
          }}
        >
          <Grid container sx={{ textAlign: "left", padding: "20px", }}>
            <Grid item xs={8} sx={{ display: "flex", alignItems: "center" }}>
              CIMB Virtual Account
            </Grid>
            <Grid item xs={4} sx={{ display: "flex", alignItems: "center" }}>
              <img src={logoCimb} alt="CIMB Logo"
                width={120} style={{ transition: "background-color 0.3s", maxWidth: "100%"  }}/>
            </Grid>
          </Grid>
        </Box>

        <Box onClick={() => setVAPaymentData("PERMATA")}
          sx={{
            ...methodItemStyle,
            border:
              paymentChannel === "PERMATA"
                ? "4px solid rgb(254, 138, 1)"
                : "2px solid black",
          }}
        >
          <Grid container sx={{ textAlign: "left", padding: "20px", }}>
            <Grid item xs={8} sx={{ display: "flex", alignItems: "center" }}>
              Permata Virtual Account
            </Grid>
            <Grid item xs={4} sx={{ display: "flex", alignItems: "center" }}>
              <img src={logoPermata} alt="PERMATA Logo"
                width={120} style={{ transition: "background-color 0.3s", maxWidth: "100%"  }}/>
            </Grid>
          </Grid>
        </Box>

        <Box onClick={() => setVAPaymentData("SAHABAT_SAMPOERNA")}
          sx={{
            ...methodItemStyle,
            border:
              paymentChannel === "SAHABAT_SAMPOERNA"
                ? "4px solid rgb(254, 138, 1)"
                : "2px solid black",
          }}
        >
          <Grid container sx={{ textAlign: "left", padding: "20px", }}>
            <Grid item xs={8} sx={{ display: "flex", alignItems: "center" }}>
              Sampoerna Virtual Account
            </Grid>
            <Grid item xs={4} sx={{ display: "flex", alignItems: "center" }}>
              <img src={logoSampoerna} alt="SAHABAT_SAMPOERNA Logo"
                width={120} style={{ transition: "background-color 0.3s", maxWidth: "100%"  }}/>
            </Grid>
          </Grid>
        </Box>

        <Box onClick={() => setVAPaymentData("BJB")}
          sx={{
            ...methodItemStyle,
            border:
              paymentChannel === "BJB"
                ? "4px solid rgb(254, 138, 1)"
                : "2px solid black",
          }}
        >
          <Grid container sx={{ textAlign: "left", padding: "20px", }}>
            <Grid item xs={8} sx={{ display: "flex", alignItems: "center" }}>
              BJB Virtual Account
            </Grid>
            <Grid item xs={4} sx={{ display: "flex", alignItems: "center" }}>
              <img src={logoBjb} alt="BJB Logo"
                width={120} style={{ transition: "background-color 0.3s", maxWidth: "100%"  }}/>
            </Grid>
          </Grid>
        </Box>

        <Box onClick={() => setVAPaymentData("BSI")}
          sx={{
            ...methodItemStyle,
            border:
              paymentChannel === "BSI"
                ? "4px solid rgb(254, 138, 1)"
                : "2px solid black",
          }}
        >
          <Grid container sx={{ textAlign: "left", padding: "20px", }}>
            <Grid item xs={8} sx={{ display: "flex", alignItems: "center" }}>
              BSI Virtual Account
            </Grid>
            <Grid item xs={4} sx={{ display: "flex", alignItems: "center" }}>
              <img src={logoBsi} alt="BSI Logo"
                width={120} style={{ transition: "background-color 0.3s", maxWidth: "100%"  }}/>
            </Grid>
          </Grid>
        </Box>
      </LiqueModal>

      <Modal
        open={successDialog}
        disableEscapeKeyDown
        aria-labelledby="success-modal-title"
        aria-describedby="success-modal-description"
        BackdropProps={{ style: { pointerEvents: "none" } }}
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            border: "2px solid #000",
            boxShadow: 24,
            p: 4,
            textAlign: "center",
          }}
        >
          <Typography id="success-modal-title" variant="h6">
            Payment Successful!
          </Typography>
          <Typography id="success-modal-description" sx={{ mt: 2 }}>
            You will be redirected to the homepage shortly.
          </Typography>
        </Box>
      </Modal>

      <LiqueModal open={informationDialog} onClose={handleCloseInformation} theme="dark" width="700px">
        <Box
          sx={{
            width: "100%"
          }}
        >
          <Box marginBottom={3}>
            <Typography sx={{ ...subHeaderStyle }}>Pay Order</Typography>
          </Box>
          <Box marginBottom={2}>
            <Typography sx={{ ...textSmallStyle }}>Total Payment</Typography>
            <Typography variant="h5" sx={{ textAlign: "left", ...headerStyle }}>
              <NumericFormat
                value={grandTotal}
                displayType={"text"}
                thousandSeparator="."
                decimalSeparator=","
                prefix={" Rp. "}
              />
            </Typography>
          </Box>
          {paymentMethod === "VIRTUAL_ACCOUNT" ? (
            <>
              <Box>
                <Typography sx={{ ...textSmallStyle }}>{ getPembayaran({ method: paymentMethod, channel: paymentChannel }) } Number</Typography>
                <Typography variant="h5" sx={{ textAlign: "left", ...headerStyle }}>
                  {paymentInfo?.virtualAccountNumber}
                </Typography>
              </Box>
            </>
          ) : (
            <>
              {
                paymentInfo?.qrCode && (
                  <Box textAlign="center" marginBottom={2}>
                    <Box sx={{ width: "fit-content", background: "white", padding: "5px", marginX: "auto" }} marginBottom={1}>
                      <QRCodeCanvas value={paymentInfo.qrCode} size={256} />
                    </Box>
                    <Typography sx={{ ...textSmallStyle }}>Scan the QR Code above to make payment</Typography>
                  </Box>
                ) 
              }
              {
                (paymentMethod === 'EWALLET' && paymentChannel === 'OVO') && (
                  <Box marginBottom={2}>
                    <Typography sx={{ ...textSmallStyle }}>Check your OVO application to make payment</Typography>
                  </Box>
                )
              }
            </>
          )}
          <Box marginTop={3}>
            <Button style={{ ...btnStyle, width: "100%", borderRadius: "50px" }} onClick={() => navigate("/customer/profile?page=history")} >
              Check Order Status
            </Button>
          </Box>
        </Box>
      </LiqueModal>
    </>
  );
};

export default CheckoutPage2;
